import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  interactive?: boolean
  onClick?: () => void
}

export default function Card({
  children,
  className = '',
  interactive = false,
  onClick,
}: CardProps) {
  const baseClasses = `
    bg-bg-surface border border-border rounded-[6px]
    shadow-card p-4
  `

  const interactiveClasses = interactive
    ? 'cursor-pointer transition-all duration-150 ease-out hover:shadow-card-hover hover:-translate-y-px'
    : ''

  return (
    <div
      className={`${baseClasses} ${interactiveClasses} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {children}
    </div>
  )
}
